import CouponBannerPage from './CouponBannerPage'
export default CouponBannerPage